function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "movie-black-18dp_1_",
  "data-name": "movie-black-18dp (1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M0,0H18V18H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  "data-name": "Path",
  d: "M12,0l1.5,3H11.25L9.75,0H8.25l1.5,3H7.5L6,0H4.5L6,3H3.75L2.25,0H1.5A1.5,1.5,0,0,0,.007,1.5L0,10.5A1.5,1.5,0,0,0,1.5,12h12A1.5,1.5,0,0,0,15,10.5V0Z",
  transform: "translate(1 3)"
}));

var SvgIconProject = function SvgIconProject(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Cart_Icon_Movie",
    "data-name": "Icon Cart/Icon Movie",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#878787",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconProject, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-project.2862cd0a.svg";
export { ForwardRef as ReactComponent };